<template>
  <div>
    <div class="banner">
      <div class="banner-content">
        <img class="img-fluid" src="../assets/images/banner/contact_banner.jpg" alt="banner" />
        <div class="banner-text">
          <h1>聯絡我們</h1>
          <div class="banner-text-line"></div>
          <span>Contact US</span>
        </div>
      </div>
    </div>
    <div class="contentContainer-noMove" :style="{backgroundImage: 'url(' + BG + ')' }">
      <div class="content">
        <div class="content-title">
          <h2>聯絡我們</h2>
          <div class="bread">
            <router-link to="/">
              <i class="fas fa-home fa-lg"></i>
            </router-link>
            <span>></span>
            聯絡我們
          </div>
        </div>
        <div class="content-contact">
          <div class="content-contact-border">
            <form
              class="form_contact"
              action="#"
              method="post"
              ref="form"
              enctype="multipart/form-data"
            >
              <div class="input_span">
                <span>姓名</span>
                <input type="text" placeholder="輸入姓名" v-model="SendData.Name" name="Name" />
              </div>
              <div class="input_span">
                <span>服務單位</span>
                <input type="text" placeholder="輸入服務單位" v-model="SendData.Affiliation" name="Affiliation" />
              </div>
              <div class="input_span">
                <span>聯絡電話</span>
                <input
                  type="text"
                  placeholder="輸入聯絡電話"
                  v-model="SendData.Phone"
                  name="Telephone"
                />
              </div>
              <div class="input_span">
                <span>E-mail</span>
                <input type="text" placeholder="輸入E-mail" v-model="SendData.Email" name="Email" />
              </div>
              <!-- <div class="input_span">
                            <span>地址</span>
                            <input
                                type="text"
                                placeholder="輸入地址"
                                v-model="SendData.Adress"
                                name="Adress"
                            />
              </div>-->
              <!-- <div class="input_span">
                            <span>請選擇問題類型</span>
                            <select v-model="SendData.QuestionType" name="QuestionType">
                                <option value="null" disabled>問題類型</option>
                                <option value="醫病諮詢">醫病諮詢</option>
                                <option value="廠商合作">廠商合作</option>
                            </select>
              </div>-->
              <div class="input_span">
                <span>標題</span>
                <input type="text" placeholder="輸入訊息標題" v-model="SendData.Title" name="Title" />
              </div>
              <div class="input_span fs">
                <span>訊息內容</span>
                <textarea placeholder="輸入訊息內容" v-model="SendData.Content" name="Content"></textarea>
              </div>
            </form>
            <div class="input_span fs">
              <span>請輸入驗證碼</span>
              <div class="id">
                <input type="text" placeholder="請輸入驗證碼" v-model="InputId" />
                <Sidentify :identifyCode="identifyCode"></Sidentify>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="35"
                  height="35"
                  viewBox="0 0 172 172"
                  style="fill:#000000;"
                  @click="refreshCode"
                >
                  <g
                    fill="none"
                    fill-rule="none"
                    stroke="none"
                    stroke-width="1"
                    stroke-linecap="butt"
                    stroke-linejoin="miter"
                    stroke-miterlimit="10"
                    stroke-dasharray
                    stroke-dashoffset="0"
                    font-family="none"
                    font-weight="none"
                    font-size="none"
                    text-anchor="none"
                    style="mix-blend-mode: normal"
                  >
                    <path d="M0,172v-172h172v172z" fill="none" fill-rule="nonzero" />
                    <g fill="#333333" fill-rule="evenodd">
                      <g id="surface1">
                        <path
                          d="M109.82357,31.85808c-13.10156,-5.76693 -27.88281,-6.66276 -41.62826,-2.32357c-26.11914,8.23047 -43.05599,33.00586 -41.29232,60.27278l-17.83268,1.17578c-2.29557,-35.5254 19.79232,-67.7754 53.75,-78.4974c19.87631,-6.27083 41.43229,-4.08724 59.71289,5.79492l17.10482,-18.2806l4.56315,50.69857l-53.69401,1.79167zM109.15169,159.51433c-7.5306,2.35156 -15.34115,3.55533 -23.0957,3.55533c-12.65365,0 -25.22331,-3.27539 -36.5612,-9.37825l-17.13281,18.30859l-4.53515,-50.69857l53.66601,-1.79167l-19.28841,20.63217c13.04557,5.73893 27.82682,6.66276 41.57226,2.32356c26.11914,-8.25846 43.08399,-33.06185 41.32031,-60.27278l17.80469,-1.17578c2.35156,35.4694 -19.76433,67.7474 -53.75,78.4974z"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
            <div class="contact-btnBlock">
              <div class="item">
                <div class="btn blue-btn islogin">
                  <a href="javascript:;" @click="Send">完成送出</a>
                </div>
              </div>
              <div class="item">
                <div class="btn white-btn islogin" @click="Reset">
                  <a href="javascript:;">重新填寫</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="contact-back">
          <router-link to="/">
            回首頁
            <img src="../assets/images/icon/back_icon.png" alt="回首頁" />
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidentify from '@/components/Identify.vue';
import contactApi from '@/assets/api/contact';
import BG from '../assets/images/index_bg_big.png';

export default {
  name: 'Contactus',
  components: {
    Sidentify,
  },
  data() {
    return {
      BG,
      // 圖形驗證
      identifyCode: '',
      // identifyCodes: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ",
      identifyCodes: '23456789ABCDEFGHJKMNPQRSTUVWXYZ',
      SendData: {
        Name: '',
        Affiliation: '',
        Phone: '',
        Email: '',
        Title: '',
        Content: '',
        CategoryId: 1,
      },
      InputId: '',
      isLoading: false,
    };
  },
  methods: {
    /* 圖形驗證 */
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCode = '';
      this.makeCode(this.identifyCodes, 4);
      // console.log("當前驗證碼==", this.identifyCode);
    },
    makeCode(o, length) {
      for (let i = 0; i < length; i += 1) {
        this.identifyCode += o[this.randomNum(0, o.length)];
      }
    },
    // eslint-disable-next-line consistent-return
    Send() {
      const vm = this;
      for (const [key, value] of Object.entries(vm.SendData)) {
        if (key !== 'Affiliation') {
          if (value === '' || value === 'null') {
            vm.$swal({
              icon: 'warning',
              text: '尚有欄位未填寫!',
              confirmButtonText: '確定',
            });
            return false;
          }
        }
      }
      if (vm.InputId !== vm.identifyCode) {
        vm.$swal({
          icon: 'warning',
          text: '驗證碼輸入錯誤!',
          confirmButtonText: '確定',
        });
        vm.refreshCode();
        return false;
      }
      vm.$store.dispatch('updateLoading', true);
      contactApi.postContact(vm.SendData).then((res) => {
        if (res.status === 200) {
          vm.$store.dispatch('updateLoading', false);
          vm.$swal({
            icon: 'success',
            text: '寄信成功，請等待3 ~ 5個工作天後將寄送信件通知!',
            confirmButtonText: '確定',
          }).then(() => { vm.Reset(); });
        } else {
          vm.$swal({
            icon: 'warning',
            text: res.data.Message,
            confirmButtonText: '確定',
          });
        }
      });

      // vm.$refs.form.submit();
    },
    Reset() {
      const vm = this;
      vm.SendData = {
        Name: '',
        Affiliation: '',
        Phone: '',
        Email: '',
        Title: '',
        Content: '',
        CategoryId: 1,
      };
    },
  },
  computed: {},
  created() {
    const vm = this;
    vm.refreshCode(); // 初始化圖形驗證
  },
  mounted() {
    const vm = this;
    if (vm.issuccess) {
      vm.$swal({
        type: 'success',
        text: '寄信成功，請等待3 ~ 5個工作天後將寄送信件通知!',
        confirmButtonText: '確定',
      });
    }
  },
  watch: {},
};
</script>
